import Seo, { SEO_FRAGMENT } from '../../components/Seo';
import fetchGql, { gql } from '../../util/fetchGql';
import Categories from '../../components/Categories';
import NewsCard, { NEWS_CARD_FRAGMENT } from '../../components/NewsCard';
import Wrap from '../../components/Wrap';

export default function News ({ seo, categories, activeCategory, posts }) {
	return (
		<>
			<Seo seo={seo} />
			<Categories
				categories={categories}
				activeId={activeCategory?.id}
			/>
			<Wrap grid>
				{posts.map(post => <NewsCard {...post} />)}
			</Wrap>
		</>
	);
}

export async function getStaticProps ({ params, ...ctx }) {
	const activeCat = params?.slug;

	const data = await fetchGql(gql`
        query News (
	        $activeCategorySlug: String
	        $relatedCat: [CategoryCriteriaInput]
        ) {
            entry (slug: "news") {
	            ... on news_news_Entry {
                    seo { ...Seo }
	            }
            }
	        categories (group: "newsCategory") {
		        ... on newsCategory_Category {
			        key: id
			        title
			        uri
		        }
	        }
	        category (slug: [$activeCategorySlug]) {
		        id
	        }
	        entries (
		        section: "post"
		        relatedToCategories: $relatedCat
	        ) {
		        ...NewsCard
	        }
        }
        ${SEO_FRAGMENT}
        ${NEWS_CARD_FRAGMENT}
	`, {
		activeCategorySlug: activeCat,
		relatedCat: activeCat ? [{ slug: [activeCat] }] : [{ search: '*' }], // shitty work-around
	}, ctx);

	const props = {
		...data.entry,
		categories: data.categories,
		activeCategory: data?.category ?? null,
		posts: data.entries,
	};

	return {
		props,
	};
}
